/* RESPONSIBLE TEAM: team-automation-foundations */
/* eslint-disable no-restricted-imports */
import {
  TRIGGERABLE_BOT_TYPE,
  USER_INACTIVITY_TARGET,
  USER_INACTIVITY_TRIGGER,
  DURING_CONVERSATION,
  WORKFLOWS_SETUP_TRIGGER_DURING_CONVERSATION,
  WORKFLOWS_SETUP_TRIGGER_CUSTOMER_FACING,
} from 'embercom/lib/operator/custom-bots/constants';
import {
  matchBehaviors,
  objectTypes,
} from 'embercom/models/data/matching-system/matching-constants';
import UserInactivityEditorConfig from 'embercom/objects/visual-builder/configuration/editor/user-inactivity-target';
import CustomBotConfig, { type ColumnConfigs } from '../custom-bot';
import type { BotConfigTarget } from '../configuration';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';
import { getApp } from 'embercom/lib/container-lookup';

export default class UserInactivityCustomBotConfig extends CustomBotConfig {
  get target(): BotConfigTarget {
    return USER_INACTIVITY_TARGET;
  }

  get botType() {
    return TRIGGERABLE_BOT_TYPE;
  }

  get objectType() {
    return objectTypes.triggerableCustomBot;
  }

  get trigger() {
    return USER_INACTIVITY_TRIGGER;
  }

  get matchBehavior() {
    return matchBehaviors.transient;
  }

  get titleTranslationKey() {
    return 'operator.custom-bot.trigger.user-inactivity.title';
  }

  get descriptionTranslationKey() {
    return 'operator.custom-bot.trigger.user-inactivity.description';
  }

  get icon(): InterfaceIconName {
    return 'snooze';
  }

  get editorConfig() {
    return new this.EditorConfigClass({
      targetChannels: this.customBot?.targetChannels,
      areStepPaywallsActive: this.areStepPaywallsActive,
      workflow: this.workflow,
    });
  }

  get EditorConfigClass() {
    return UserInactivityEditorConfig;
  }

  get columnKeys(): (keyof ColumnConfigs)[] {
    let baseColumns: (keyof ColumnConfigs)[] = super.columnKeys;
    let idx = 2;

    if (getApp().canUseFeature('team-workflows-workflow-type-column')) {
      idx++;
    }

    return [...baseColumns.slice(0, idx), 'channels', ...baseColumns.slice(idx)];
  }

  get requiredBillingFeature() {
    return 'inbox_rules';
  }

  get triggerContextType() {
    return DURING_CONVERSATION;
  }

  get workflowsSetupTriggerType(): string[] {
    return [WORKFLOWS_SETUP_TRIGGER_DURING_CONVERSATION, WORKFLOWS_SETUP_TRIGGER_CUSTOMER_FACING];
  }
}
